/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { LogOptions, LogResponses } from '../../models/Log'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Post Logs
 * {@link /logs}
 */
export function log<ThrowOnError extends boolean = true>(options: Options<LogOptions, ThrowOnError>): Promise<UnwrappedResult<LogResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'POST', url: '/logs', ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<LogResponses, ThrowOnError>>
}
